import type { ChatMediaType } from 'cpool-constants';
import { CHAT_MEDIA_TYPES } from 'cpool-constants';

// Stickers are inbound-only and require a pre-registered webp format — never derived from an upload mimeType.
export function deriveMediaTypeFromMimeType(mimeType: string): Exclude<ChatMediaType, 'sticker'> {
    if (mimeType.startsWith('image/')) return CHAT_MEDIA_TYPES.IMAGE;
    if (mimeType.startsWith('video/')) return CHAT_MEDIA_TYPES.VIDEO;
    if (mimeType.startsWith('audio/')) return CHAT_MEDIA_TYPES.AUDIO;
    return CHAT_MEDIA_TYPES.DOCUMENT;
}
